<template>
  <v-card elevation="0" rounded="pill" @click="$emit('click')">
    <div class="d-flex py-2">
      <div class="d-flex flex-row flex-grow-1 align-center">
        <v-avatar size="50" class="ml-3 my-auto" :color="avatarColor">
          <v-img
            v-if="avatarPicture"
            :src="avatarPicture"
            :lazy-src="avatarPicture"
            height="42"
            max-width="42"
            :aspect-ratio="1 / 1"
          />
        </v-avatar>
        <v-avatar v-if="secondaryAvatarPicture" size="50" class="ml-n4 my-auto" :color="avatarColor">
          <v-img
            :src="secondaryAvatarPicture"
            :lazy-src="secondaryAvatarPicture"
            height="42"
            max-width="42"
            :aspect-ratio="1 / 1"
          />
        </v-avatar>
        <div class="d-flex ml-2 text-left flex-grow-1 flex-column">
          <div class="d-flex justify-space-between">
            <h6 class="secondary--text text-h6">{{ title }}</h6>
            <v-chip v-if="showDone" small color="nutrition" class="white--text font-weight-bold mr-5">DONE</v-chip>
          </div>
          <div class="mid-grey--text d-flex">with {{ subTitle }}</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";

export default {
  name: "BlockHeaderCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
    },
    accentColor: {
      type: String,
      required: false,
      default: "navy",
    },
    avatarPicture: {
      type: String,
      required: false,
    },
    secondaryAvatarPicture: {
      type: String,
      required: false,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    showDone: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    avatarColor() {
      return this.accentColor;
    },
  },
};
</script>
